/**
 * Browser edge IDs for backend observability headers.
 * Session correlationId spans the page; requestId is unique per HTTP call.
 */

function newId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // ponytail: older browsers — upgrade path is crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let sessionCorrelationId = null;

export function getSessionCorrelationId() {
  if (!sessionCorrelationId) {
    sessionCorrelationId = newId();
  }
  return sessionCorrelationId;
}

export function nextRequestIds() {
  const requestId = newId();
  return {
    requestId,
    correlationId: getSessionCorrelationId(),
  };
}

export function correlationHeaders() {
  const { requestId, correlationId } = nextRequestIds();
  return {
    'x-request-id': requestId,
    'x-correlation-id': correlationId,
    requestId,
    correlationId,
  };
}
